
import { defineComponent, PropType } from 'vue';

// Models
import { Filter } from '../../CoffeePicker.model';

export default defineComponent({
  props: {
    activeFilters: Array as PropType<Filter[]>,
    toggleFilterOption: Function as PropType<(filter: Filter) => void>,
  },
});
